import { useIntl } from "react-intl";
import { AccountSettings } from "pages/settings/AccountSettings";
import { ResultPage, ResultType } from "pages/success/ResultPage";
import { Navigate, Route, Routes } from "react-router-dom";
import { StudioLogin } from "pages/studio-login/StudioLogin";

export function AccountRoutes() {
  return (
    <Routes>
      <Route path="/settings/*" element={<AccountSettings />} />
      <Route path="/studio-login" element={<StudioLogin />} />
      <Route path="/success" element={<Success />} />
      <Route path="/" element={<Navigate to="/settings" />} />
    </Routes>
  );
}

function Success() {
  const intl = useIntl();

  return (
    <ResultPage
      type={ResultType.SUCCESS}
      title={intl.formatMessage({ id: "jmix-account.request-sent.title" })}
      subTitle={intl.formatMessage({ id: "jmix-account.request-sent.subtitle" })}
    />
  );
}